module.exports = __webpack_public_path__ + "static/media/Icon-07@2x.939ae69e.png";